import { TableV2 } from '@anytag/shared-atoms';
import { InstagramReelPostItem } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerInstagramAnalyticsReelDetailsModal } from '@anytag/shared-molecules';
import { useInfluencerInstagramReelPostsListTable } from './hooks';

export interface InfluencerInstagramReelPostsListProps extends TableData<InstagramReelPostItem> {
  mainSocialAccountId?: number;
}

export const InfluencerInstagramReelPostsList = ({
  loading,
  data = [],
  mainSocialAccountId
}: InfluencerInstagramReelPostsListProps) => {
  const { columns } = useInfluencerInstagramReelPostsListTable();

  return (
    <>
      <TableV2 loading={loading} rowHeight="62px" columns={columns} data={data} noTopBorderRadius hasBorder />

      <InfluencerInstagramAnalyticsReelDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
      />
    </>
  );
};
